import React from 'react';

import type { Section } from '../../../../models';
import { HEATING_OIL } from '../../../../constants';
import UtilitiesIndividuallyMetered from '../Utilities/UtilitiesCalculation/UtilitiesIndividuallyMetered';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingOilIndividuallyMetered({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesIndividuallyMetered
      section={section}
      setSectionValues={setSectionValues}
      utilityIndividuallyMeteredField={HEATING_OIL.FIELD_NAME.INDIVIDUALLY_METERED}
      utilityName="Heating oil"
    />
  );
}

export default HeatingOilIndividuallyMetered;
